import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Type, cssColorValue, spacer12, spacer48, spacer24 } from '@spotify-internal/encore-web';
import { useTracking } from '../Tracking';
import { ButtonPrimaryAsLink } from '../ui';
import { defaultTheme } from '../Theme';
import { PageHead } from './PageHead';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Layout = styled.div.withConfig({
  displayName: "NotFound__Layout",
  componentId: "sc-7h30xu-0"
})(["display:flex;width:100%;background-color:", ";padding:120px ", ";"], cssColorValue('essentialAnnouncement'), spacer24);
var Content = styled.div.withConfig({
  displayName: "NotFound__Content",
  componentId: "sc-7h30xu-1"
})(["width:100%;max-width:800px;text-align:center;margin:auto;p{margin-top:", ";margin-bottom:", ";}"], spacer48, spacer12);
export var NotFound = function NotFound() {
  var t = useT();

  var _useTracking = useTracking(),
      sendEvent = _useTracking.sendEvent;

  React.useEffect(function () {
    sendEvent({
      eventCategory: "Frodor - Not Found",
      eventAction: 'view',
      eventLabel: 'Not Found'
    });
  }, []);
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: defaultTheme,
    "data-testid": "not-found",
    children: [/*#__PURE__*/_jsx(PageHead, {
      title: t('FRODOR_a9cd45', 'Not found', '')
    }), /*#__PURE__*/_jsx(Layout, {
      children: /*#__PURE__*/_jsxs(Content, {
        children: [/*#__PURE__*/_jsx(Type.h1, {
          variant: "display2",
          children: t('FRODOR_8ecf25', 'We couldn’t find that page.', "Couldn't means could not")
        }), /*#__PURE__*/_jsx(Type.p, {
          variant: "body1",
          children: t('FRODOR_1660a4', 'The link may be broken or we’ve taken the page down.', 'Link here refers to a web link')
        }), /*#__PURE__*/_jsx(ButtonPrimaryAsLink, {
          href: "/?ref=error",
          prefetch: false,
          children: t('FRODOR_998bb6', 'Our Homepage', '')
        })]
      })
    })]
  });
};